const BASE_URL = "https://lmsapi.brightinfovision.com/api"; // Base API URL

const API_URLS = {
  // User-related endpoints
  LOGIN: `${BASE_URL}/tutor/login`,
  REGISTER: `${BASE_URL}/tutor/signup`,
  PROFILE: `${BASE_URL}/tutor/profile`,
  UPDATE_USER: `${BASE_URL}/tutor/update`,
  COURSES_CATEGORIES:`${BASE_URL}/tutor/coursecategory/list`,
  COURSES_CATEGORY_SAVE:`${BASE_URL}/tutor/coursecategory/save`,
  COURSES_CATEGORY_DELETE:`${BASE_URL}/tutor/coursecategory/delete`,
  COURSES_FULL_DETAIL:`${BASE_URL}/tutor/course/fulldetails`,
  COURSES:`${BASE_URL}/tutor/course/list`,
  COURSES_SAVE:`${BASE_URL}/tutor/course/save`,
  COURSES_DELETE:`${BASE_URL}/tutor/course/delete`,
  CKEDITOR_UPLOAD:`${BASE_URL}/ckeditor/upload`,
  CHAPTER_SAVE:`${BASE_URL}/tutor/chapter/save`,
  CHAPTER_DELETE:`${BASE_URL}/tutor/chapter/delete`, 
  PAGE_SAVE:`${BASE_URL}/tutor/page/save`,
  PAGE_DELETE:`${BASE_URL}/tutor/page/delete`,
  
};

export default API_URLS;
